import { Link, useLocation } from "react-router-dom";
import { Texts, Media } from "../../Object/";
import Nav from "./Nav";
import { useRef, useEffect, useMemo, useState } from "react";
import { useToggle, useOffsetTop } from "../../Hooks";

const Header = () => {
  const location = useLocation();
  const headerRef = useRef(null);
  const { pageOffsetTop, viewportTop } = useOffsetTop(headerRef);
  const [active, setActive] = useState(false); // ファーストビューからスクロール後にactive化
  const [open, toggleOpen] = useToggle(false);
  
  // elment args
  const args = {
    nav: {
      remove: [''],
      position: 'header',
      open: open,
      toggleOpen: toggleOpen,
    },
    header: {
      ref: headerRef,
      className: active || open ? "l-header__wrap l-header__wrap--active" : "l-header__wrap",
    },
    contactButton: {
      src: 'common/icon-contact',
      alt: 'contact',
      class: 'l-header__img--contact'
    }
  }

  const border = useMemo(() => {
    // 位置を取得できなかったときは最大サイズとして表示
    if (pageOffsetTop > 800) {
      setActive(true);
    } else {
      setActive(false);
    }
    // 位置に応じてサイズ計算
  }, [pageOffsetTop, viewportTop]);

  useEffect(() => {
    if (open) {
      toggleOpen(false);
    }
  }, [location]);
  
  // ロゴアイコン（リンク付き　トップ）
  const Logo = () => {
    return (
      <Link to="/">
        <Media
          src="common/icon-logo-text"
          alt="icon-logo"
          class="l-header__img--logo"
          sp="sp"
        ></Media>
      </Link>
    )
  }
  
  // メニューボタン
  const NavButton = () => {
    return(
      <button className="l-header__button" onClick={() => toggleOpen()}>
        <Media src="common/icon-menu" alt="menu"></Media>
      </button>
    )
  }
  
  const FixContactButton = () => {
    return(
      <>
        <Link className="l-header__button--contact" to="/contact">
          <Texts class="c-text--bold p-nav__link" slug="header/contact"></Texts>
        </Link>
      </>
    )
  }

  return (
    <>
      {/* <FixContactButton /> */}
      <header {...args.header}>
        <div className="l-header__wrap--inner">
          <Logo />
          <Nav {...args.nav} />
        </div>
    
        <NavButton></NavButton>
      </header>

    </>
  );
};

export default Header;
